import { applyScheduleEdits, type SavedSchedule } from './scheduleWrites';

/** One schedule's editable draft. Coalesce rapid edits without losing in-flight changes. */
export class ScheduleDraft {
  saved: SavedSchedule;
  current: SavedSchedule;
  private revision = 0;
  private savedRevision = 0;
  private extra: Record<string, unknown> = {};
  private running: Promise<void> | null = null;

  constructor(initial: SavedSchedule) { this.saved = initial; this.current = initial; }

  /** Live updates must not advance the conflict baseline beneath an unsaved edit. */
  receive(latest: SavedSchedule): boolean {
    if (this.running || this.revision !== this.savedRevision) return false;
    this.saved = latest;
    this.current = latest;
    return true;
  }

  edit(base: SavedSchedule, next: SavedSchedule, extra: Record<string, unknown> = {}) {
    this.current = applyScheduleEdits(this.current, base, next);
    this.extra = { ...this.extra, ...extra };
    this.revision++;
  }

  flush(persist: (next: SavedSchedule, previous: SavedSchedule, extra: Record<string, unknown>) => Promise<SavedSchedule>): Promise<void> {
    if (this.running) return this.running;
    this.running = (async () => {
      while (true) {
        const revision = this.revision;
        const candidate = this.current;
        const committed = await persist(candidate, this.saved, this.extra);
        this.saved = committed;
        this.savedRevision = revision;
        this.current = applyScheduleEdits(committed, candidate, this.current);
        if (revision === this.revision) { this.extra = {}; return; }
      }
    })().finally(() => { this.running = null; });
    return this.running;
  }
}
